export const PRODUCER_ID =  1;
export const COVERHOLDER_ID =  2;

export const PREFIX_PRODUCER =  '/producer-products';
export const PREFIX_COVERHOLDER =  '/coverholder-products';

class ProductOwnerModel {
}

export default ProductOwnerModel;
